import { render, staticRenderFns } from "./IbUserAvatar.vue?vue&type=template&id=85648314"
import script from "./IbUserAvatar.vue?vue&type=script&lang=js"
export * from "./IbUserAvatar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports